var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Agregar Dato Extendido" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("GuardarButton", {
            attrs: { disabled: _vm.hasErrors, "data-testid": "GuardarDato" },
            on: { click: _vm.handleGuardarClick }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c(
            "v-stepper-items",
            { staticClass: "cardnew" },
            [
              _c(
                "v-stepper-content",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: { step: _vm.pasos.informacionGeneral.step }
                },
                [
                  _c("DatoExtendidoForm", {
                    attrs: {
                      "test-id": "CrearDatoExtendidoModal",
                      datoExtendido: _vm.datoExtendido,
                      dispositivoId: _vm.dispositivoId,
                      editar: "0"
                    },
                    on: { change: _vm.handleFormChange }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: "\n      Agregar Dato Extendido\n    ",
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar"),
          "test-id": "ConfirmacionGuardarDato"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.crear.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.crear.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionCerrar }
      }),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.$t("Condición Visible"),
          mensaje: _vm.$t("Debe ingresar valor en campo Condición Visible")
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }